import React, { Component } from "react";
import {
  Alert,
  Dimensions,
  Image,
  Platform,
  ScrollView,
  Text,
  TextInput,
  TouchableOpacity,
  TouchableWithoutFeedback,
  View,
  SafeAreaView,
} from "react-native";
import Slider from "react-native-slider";
import PickerSelect from "react-native-picker-select";
import Header from "../components/Header";
import Accordion from "react-native-collapsible/Accordion";
import DateTimePicker from "@react-native-community/datetimepicker";
import _ from "lodash";
import { connect } from "react-redux";
import { APP_BASE_URL } from "../helpers/storage";
import fonts from "../constants/fonts";
import { API } from "../helpers/axios";

class SymptomsScreen extends Component {
  constructor(props) {
    super(props);

    this.state = {
      consultation: "",
      duration: 0,
      activeSections: [],
      symptoms: [],
      symptomsSimple: [],
      selectedUnit: "day",
      patientDob: "",
      showDatePicker: false,
    };
  }

  async fetchSymptoms() {
    try {
      const {
        data: { data: symptoms },
      } = await API.get(`${APP_BASE_URL}/v2/info/complaints`);

      this.setState({
        symptoms,
        symptomsSimple: _.map(
          _.groupBy(symptoms, "complaint_group"),
          (item, key) => {
            return {
              name: key,
              items: item.map((item) => {
                return Object.assign({}, item, {
                  selected: false,
                });
              }),
            };
          }
        ),
      });
    } catch (error) {
      console.log(error?.response || error);
    }
  }

  componentDidMount() {
    this.promise = this.fetchSymptoms();
  }

  _renderHeader = (section) => {
    return (
      <View
        style={{
          padding: 20,
          borderTopColor: "#707070",
          borderTopWidth: 1,
          borderTopEndRadius: 20,
          borderTopStartRadius: 20,
          flexDirection: "row",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Text
          style={{
            color: "#707070",
            fontSize: 18,
            ...fonts.bold,
            flexGrow: 1,
          }}
        >
          {section.name}
        </Text>
        <Image
          source={require("../assets/round_keyboard_arrow_down_black_18dp.png")}
        />
      </View>
    );
  };

  _renderContent = (section) => {
    const chunks = _.chunk(section.items, 2);
    return (
      <View style={{ padding: 5 }}>
        {chunks.map((chunk, index) => {
          return (
            <View key={index} style={{ flexDirection: "row" }}>
              {chunk.map((item) => {
                return (
                  <TouchableOpacity
                    style={{ flex: 0.5 }}
                    key={item["id"]}
                    onPress={() => {
                      this.setState({
                        symptomsSimple: this.state.symptomsSimple.map((a) => {
                          return {
                            name: a.name,
                            items: a.items.map((b) => {
                              return b["id"] === item["id"]
                                ? Object.assign({}, b, {
                                    selected: !b.selected,
                                  })
                                : b;
                            }),
                          };
                        }),
                      });
                    }}
                  >
                    <View
                      style={{
                        padding: 10,
                        margin: 10,
                        borderRadius: 20,
                        borderColor: item["selected"] ? "#5DBE66" : "#808080",
                        borderWidth: 2,
                        alignItems: "center",
                      }}
                    >
                      <Text
                        style={{
                          color: "#808080",
                          fontSize: 16,
                          ...fonts.regular,
                        }}
                      >
                        {item["complaint_name"]}
                      </Text>
                    </View>
                  </TouchableOpacity>
                );
              })}
            </View>
          );
        })}
      </View>
    );
  };

  _updateSections = (activeSections) => {
    this.setState({ activeSections });
  };

  onDatePickerChange = (_event, selectedDate) => {
    const patientDob = selectedDate || this.state.patientDob;
    // setShow(Platform.OS === "ios");
    this.setState({ patientDob, showDatePicker: false });
  };

  showDatePickerHandler = () => {
    this.setState({ showDatePicker: true });
  };

  formatDate = (date) => {
    if(!date) return "Lengkapi Tanggal Lahir Anda"
    return `${date.getDate()}/${date.getMonth() + 1}/${date.getFullYear()}`;
  };

  render() {
    const fm1 = _.flatMap(this.state.symptomsSimple, (item) => item.items);
    const fm2 = _.filter(fm1, (item) => item.selected);
    const fm3 = _.map(fm2, (item) => item["complaint_name"]);
    const fm4 = _.map(fm2, (item) => item["id"]);

    const symptomsSummary = fm3.join(", ");

    return (
      <View
        style={{
          backgroundColor: this.props.themeColors.primary,
          flex: 1,
        }}
      >
        <ScrollView>
          <SafeAreaView>
            <Header
              onPress={() => {
                this.props.navigation.goBack();
              }}
              position="start"
              text="Batal"
              theme="light"
            />
          </SafeAreaView>
          {!this.props.navigation.state.params.hasDoB && (
            <View style={{ padding: 20, paddingTop: 10 }}>
              <TouchableOpacity onPress={this.showDatePickerHandler}>
                <View
                  style={{
                    borderRadius: 20,
                    paddingHorizontal: 20,
                    paddingVertical: 20,
                    backgroundColor: "#FFFFFF",
                    minHeight: 50,
                  }}
                >
                  <Text
                    style={{
                      paddingHorizontal: 30,
                      fontSize: 18,
                      ...fonts.bold,
                      color: this.props.themeColors.darkestPrimary,
                      marginBottom: 10,
                      alignSelf: "center",
                    }}
                  >
                    Tanggal Lahir:
                  </Text>
                  <Text
                    style={{
                      alignSelf: "center",
                    }}
                  >
                    {this.formatDate(this.state.patientDob)}
                  </Text>
                </View>
              </TouchableOpacity>
            </View>
          )}
          {this.state.showDatePicker && (
            <DateTimePicker
              testID="dateTimePicker"
              value={this.state.patientDob || new Date()}
              mode={"date"}
              display={Platform.select({ ios: "default", android: "spinner" })}
              maximumDate={Date.parse(new Date())}
              onChange={this.onDatePickerChange}
            />
          )}
          <View style={{ padding: 20, paddingTop: 0 }}>
            <TouchableWithoutFeedback onPress={() => this.inputRef.focus()}>
              <View
                style={{
                  borderRadius: 20,
                  paddingHorizontal: 20,
                  paddingVertical: 10,
                  backgroundColor: "#FFFFFF",
                  minHeight: 100,
                }}
              >
                <TextInput
                  ref={(ref) => {
                    this.inputRef = ref;
                  }}
                  value={this.state.consultation}
                  onChangeText={(value) =>
                    this.setState({ consultation: value })
                  }
                  placeholder="Tuliskan Keluhan Utama Anda"
                  multiline={true}
                  maxLength={250}
                  textAlignVertical="top"
                />
              </View>
            </TouchableWithoutFeedback>
          </View>
          <View style={{ padding: 20, paddingTop: 0 }}>
            <View
              style={{
                paddingVertical: 20,
                paddingHorizontal: 10,
                backgroundColor: "#FFFFFF",
                borderRadius: 20,
              }}
            >
              <Text
                style={{
                  paddingHorizontal: 30,
                  fontSize: 18,
                  ...fonts.bold,
                  color: this.props.themeColors.darkestPrimary,
                  marginBottom: 10,
                  alignSelf: "center",
                }}
              >
                Lama Keluhan:
              </Text>
              <View style={{ flexDirection: "row", paddingLeft: 20 }}>
                <Slider
                  style={{ flexGrow: 1, alignSelf: "center" }}
                  onValueChange={(value) => this.setState({ duration: value })}
                  minimumTrackTintColor={this.props.themeColors.lighterPrimary}
                  maximumTrackTintColor={this.props.themeColors.lightestPrimary}
                  step={1}
                  minimumValue={0}
                  maximumValue={13}
                  thumbTintColor={this.props.themeColors.darkerPrimary}
                />
                <View
                  style={[
                    {
                      marginStart: 20,
                      width: 100,
                    },
                    Platform.OS === "android"
                      ? {
                          alignItems: "center",
                        }
                      : null,
                  ]}
                >
                  <Text
                    style={{
                      fontSize: 27,
                      ...fonts.bold,
                      paddingHorizontal: 10,
                      color: this.props.themeColors.lighterPrimary,
                    }}
                  >
                    {this.state.duration > 12 ? "12+" : this.state.duration}
                  </Text>
                  <PickerSelect
                    onValueChange={(itemValue) => {
                      this.setState({
                        selectedUnit: itemValue,
                      });
                    }}
                    useNativeAndroidPickerStyle={false}
                    items={[
                      {
                        label: "Hari",
                        value: "day",
                      },
                      {
                        label: "Minggu",
                        value: "week",
                      },
                      {
                        label: "Bulan",
                        value: "month",
                      },
                    ]}
                    style={{
                      inputIOS: {
                        fontSize: 16,
                        paddingVertical: 12,
                        paddingHorizontal: 10,
                        color: "black",
                        paddingRight: 30,
                      },
                      inputAndroid: {
                        fontSize: 16,
                        paddingHorizontal: 10,
                        paddingVertical: 8,
                        color: "black",
                        paddingRight: 30,
                      },
                      iconContainer: {
                        top: 10,
                      },
                    }}
                    placeholder={{}}
                    Icon={() => {
                      return (
                        <Image
                          style={{ height: 24, width: 24 }}
                          source={require("../assets/round_keyboard_arrow_down_black_18dp.png")}
                        />
                      );
                    }}
                  />
                </View>
              </View>
            </View>
          </View>
          <View>
            <View>
              <Text
                style={{
                  marginHorizontal: 30,
                  color: "#FFFFFF",
                  fontSize: 18,
                  ...fonts.bold,
                  marginTop: 25,
                  alignSelf: "center",
                }}
              >
                Keluhan Tambahan:
              </Text>
              <Text
                style={{
                  marginHorizontal: 30,
                  color: "#FFFFFF",
                  fontSize: 18,
                  ...fonts.light,
                  marginBottom: 25,
                  alignSelf: "center",
                }}
              >
                {symptomsSummary || "-"}
              </Text>

              <View
                style={{
                  backgroundColor: "#FFF",
                  marginHorizontal: 10,
                  borderRadius: 20,
                  marginBottom: 10,
                }}
              >
                <Accordion
                  touchableComponent={TouchableOpacity}
                  sections={this.state.symptomsSimple}
                  activeSections={this.state.activeSections}
                  renderHeader={this._renderHeader}
                  renderContent={this._renderContent}
                  onChange={this._updateSections}
                />
              </View>
            </View>
          </View>
        </ScrollView>
        <View style={{ backgroundColor: "#FFFFFF" }}>
          <View
            style={{
              backgroundColor: "rgba(0, 0, 0, 0.16)",
              height: 3,
              width: Dimensions.get("window").width,
            }}
          />
          <View style={{ padding: 20 }}>
            <TouchableOpacity
              onPress={() => {
                if (
                  this.state.consultation.length === 0 ||
                  this.state.duration === 0 ||
                  (!this.props.navigation.state.params.hasDoB && !this.state.patientDob)
                ) {
                  Alert.alert(
                    "Kesalahan",
                    `Isi ${
                      !this.props.navigation.state.params.hasDoB
                        ? "tanggal lahir, keluhan, dan durasi"
                        : "keluhan dan durasi"
                    } sejak kapan keluhan dirasakan sebelum memulai konsultasi dengan dokter.`
                  );

                  return;
                }

                this.props.navigation.replace("Consent", {
                  ...this.props.navigation.state.params,
                  // params passed {
                  //   patientId,
                  //   fullName,
                  //   hasViId,
                  //   enableVoiceCall,
                  //   enableVideoCall,
                  //   clientId,
                  // }
                  cardNumberDependency: this.props.navigation.state.params
                    ? this.props.navigation.state.params.policyNumber
                    : null,
                  consultation: this.state.consultation,
                  symptomsSummary,
                  complaintIds: fm4,
                  duration: this.state.duration,
                  durationUnit: this.state.selectedUnit,
                  patientDob: this.state.patientDob
                });
              }}
            >
              <View
                style={{
                  marginBottom: 0,
                  paddingVertical: 10,
                  paddingHorizontal: 40,
                  backgroundColor: "#5DBE66",
                  borderRadius: 20,
                  alignSelf: "center",
                }}
              >
                <Text
                  style={{
                    fontSize: 16,
                    ...fonts.bold,
                    color: "#FFFFFF",
                  }}
                >
                  Selanjutnya
                </Text>
              </View>
            </TouchableOpacity>
          </View>
        </View>
      </View>
    );
  }
}

export default connect((state) => ({
  themeColors: state.themeColors,
}))(SymptomsScreen);
